import KpiGrid from "./KpiGrid";

const OverviewTab = ({ kpis }) => (
  <div className="space-y-4">
    <KpiGrid kpis={kpis} />
  </div>
);

export default OverviewTab;
